import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link} from "@reach/router";

class NewsList extends Component{
  //when <Link to=same url different param not work/>
  click = (e)=>{
    const url = this.props.data.url.startsWith('../') ? this.props.data.url.substring(3, this.props.data.url.length) : this.props.data.url;
    document.location.href = url;
    e.prefentDefault();
    return false;
  }

  render(){
    return(
      <>
      <li className="bp-item">
        <div className="pointer" onClick={this.click}>
        <span className="bpi-left"><div className="bpi-left-img"><img src={this.props.data.image} /></div></span>
        <span className="bpi-right">{ this.props.data.title }</span>
        </div>
      </li>
      </>
    );
  }
}

export default NewsList;

